import { Provider } from "jotai";
import React, { useEffect } from "react";
import styled from "styled-components";
import Home from "./Home";
import { randomRange } from "@stores/vars";

const AppWrap = styled.div`
  position: absolute;
  width: 1920px;
  height: 1200px;
`;

function App() {
  useEffect(() => {
    const isMan = randomRange(0, 1) === 0;
    const charRan = isMan ? randomRange(0, 3) : randomRange(0, 2);
    window.__welcomeRandom = [isMan, charRan];

    const WIDTH = 1920;
    const HEIGHT = 1200;
    const root = document.querySelector("#App");
    const resize = () => {
      const cw = window.innerWidth;
      const ch = window.innerHeight;
      const ratio =
        Math.min(cw / WIDTH, ch / HEIGHT) >= 1
          ? 1
          : Math.min(cw / WIDTH, ch / HEIGHT);
      const cwper = (cw - WIDTH * ratio) / 2;
      const chper = (ch - HEIGHT * ratio) / 2;
      window.__scale = ratio;
      document.body.style.setProperty("--stage-per", window.__scale);
      Object.assign(root.style, {
        transformOrigin: `0 0`,
        transform: `scale(${ratio})`,
        left: `${cwper}px`,
        top: `${chper}px`,
        backgroundColor: "#122546",
      });
    };

    window.addEventListener("resize", resize);
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "visible") {
        if (window.__bgmSound) {
          window.__bgmSound.play();
        }
      } else {
        if (window.__bgmSound) {
          window.__bgmSound.pause();
        }
      }
    });

    resize();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <AppWrap id="App">
      <Provider>
        <React.Suspense fallback={<div></div>}>
          <Home />
        </React.Suspense>
      </Provider>
    </AppWrap>
  );
}

export default App;
